import useFlag from '@proton/unleash/useFlag';

export function useFlagsDriveFoundationSearch() {
    return useFlag('DriveWebSearchFoundation');
}
